import React, { ReactNode, useContext, useState, useEffect } from "react";
import { patchModels } from "./patchModels";

interface Props {
  children: ReactNode;
}

export const DefinitionContext = React.createContext<any>(undefined);

export function DefinitionProvider({ children }: Props): JSX.Element {
  const [defs, setDefs] = useState<any>(undefined);

  useEffect(() => {
    const fetchYAMLFiles = async () => {
      try {
        const __specs__ = await fetch("/definitions/__specs__.json", ).then(res => res.json());
        const obj: any = {__specs__};
        for (const collectionKey of Object.keys(__specs__)) {
          const coll = await fetch(`/definitions/${collectionKey}.json`).then(res => res.json());
          obj[collectionKey] = coll;
        }

        const combinedDefs = patchModels(obj);
        setDefs(combinedDefs);
      } catch (error) {
        console.error("Error fetching or parsing YAML files:", error);
      }
    };

    fetchYAMLFiles();
  }, []);

  if (defs === undefined) {
    return <div>Loading...</div>;
  }

  return (
    <DefinitionContext.Provider value={defs}>
      {children}
    </DefinitionContext.Provider>
  );
}

export function useDefinitions() {
  const context = useContext(DefinitionContext);
  if (context === undefined) {
    throw new Error("useDefinitions must be used within a DefinitionContext");
  }
  return context;
}